import _mixin from '../_mixin'

export default {
  name: 'SVersionActivity',
  cnName: '固定版本活动',
  type: 'activity_other',
  preview: 'https://rescdn.ssjj.cn/website/2024/05/17/1f251f33e8d30b965516cb67201f8eda.jpg',
  // 属性相关
  props: {
    part1Id: 'version-data-1',
    part2Id: 'version-data-2',
    part3Id: 'version-data-3',
    part4Id: 'version-data-4',
    part5Id: 'version-data-5',
    part6Id: 'version-data-6',
    part7Id: 'version-data-7',
    part8Id: 'version-data-8',
    ruleId: '6502a025c720be4224530c45',
    mainHeight: '8135px',
    part1Top: '0px', // 活动1位置
    part1Obj: [
      {
        bgWidth: '1920px',
        bgHeight: '1543px',
        bgSrc: 'https://rescdn.ssjj.cn/website/2025/03/17/66939946808887dae94f0dc2e450d9a1.jpg'
      }
    ],
    lotteryCost: 1,
    lotteryBtn: [
      {
        left: '900px',
        bottom: '930px',
        btnWidth: '185px',
        btnHeight: '60px',
        btnSrc: 'https://rescdn.ssjj.cn/website/2025/04/18/d6938d5af849cb91ec065e7b97ae22a8.png'
      }
    ],
    lotteryTenBtn: [
      {
        left: '1100px',
        bottom: '930px',
        btnWidth: '185px',
        btnHeight: '60px',
        btnSrc: 'https://rescdn.ssjj.cn/website/2025/04/18/f335a60646525b4983bd9f60d10a5c43.png'
      }
    ],
    part1Btn: [
      {
        left: '260px',
        bottom: '610px',
        btnWidth: '165px',
        btnHeight: '50px',
        btnSrc: 'https://rescdn.ssjj.cn/website/2025/03/17/3928eded92791acd162b9d2d386a6af7.png'
      }
    ],
    part1TextStyle: [
      {
        fontSize: '26px',
        color: '#FDD738',
        top: '424px',
        left: '1067px'
      }
    ],
    part1Rule: [
      {
        left: '1100px',
        bottom: '800px',
        btnWidth: '156px',
        btnHeight: '40px',
        btnSrc: 'https://rescdn.ssjj.cn/website/2025/03/17/73a6c90c032ad735adbc1815657c9b8b.png'
      }
    ],
    part1Record: [
      {
        left: '920px',
        bottom: '800px',
        btnWidth: '156px',
        btnHeight: '40px',
        btnSrc: 'https://rescdn.ssjj.cn/website/2025/03/17/c2a94dede49d04b3e029a0520b6963a0.png'
      }
    ],
    prat1ReciveGiftBox: [
      {
        width: '1555px',
        height: '50px',
        btnWidth: '165px',
        btnHeight: '50px',
        bottom: '100px',
        left: '184px'
      }
    ],
    prat1ReciveTextBox: [
      {
        width: '1555px',
        height: '50px',
        bottom: '355px',
        left: '184px',
        fontSize: '26px',
        color: '#FDD738'
      }
    ],
    // buyCoinId: '4895', // 货币购买商品id
    // weaponCoinId: '4896', // 武器直购商品id

    part2Top: '1543px', // 活动2位置

    part2Obj: [
      {
        bgWidth: '1920px',
        bgHeight: '1065px',
        bgSrc: 'https://rescdn.ssjj.cn/website/2025/03/17/f80a7f964439600a22cbc898e17d5dee.jpg',
        itemWidth: '452px',
        itemHeight: '126px',
        btnSrc: 'https://rescdn.ssjj.cn/website/2025/03/17/7e9e66fd6b309745bdaeed4f64247bd2.png',
        left: '880px',
        bottom: '200px'
      }
    ],
    part2Btn: [
      {
        btnWidth: '166px',
        btnHeight: '91px'
      }
    ],

    part3Top: '2608px', // 活动3位置
    part3BtnsFirst: [
      {
        left: '440px',
        bottom: '100px'
      }
    ],
    part3BtnsOther: [
      {
        boxWidth: '850px',
        boxHeight: '429px',
        left: '918px',
        bottom: '73px'
      }
    ],

    part3Obj: [
      {
        bgWidth: '1920px',
        bgHeight: '1017px',
        bgSrc: 'https://rescdn.ssjj.cn/website/2025/03/18/7269af6dbaa7645e337d235eb435bb48.png',
        itemWidth: '165px',
        itemHeight: '50px'
      }
    ],
    part3Btn: [
      {
        btnWidth: '166px',
        btnHeight: '91px'
      }
    ],

    part4Top: '3620px', // 版本累登活动位置
    part4LoginCount: [
      {
        fontSize: '26px',
        color: '#000000',
        left: '1780px',
        bottom: '620px'
      }
    ],
    part4Btns: [
      {
        itemWidth: '166px',
        itemHeight: '50px',
        bgWidth: '1920px',
        bgHeight: '793px',
        boxWidth: '1580px',
        bottom: '80px',
        left: '166px',
        boxHeight: '60px',
        bgSrc: 'https://rescdn.ssjj.cn/website/2025/03/18/891e73045ecf05821948f13ad2683ae3.png'
      }
    ],

    part5Top: '4410px', // 周末福利活动位置
    part5Btns: [
      {
        itemWidth: '166px',
        itemHeight: '50px',
        bgWidth: '1920px',
        bgHeight: '727px',
        boxWidth: '1580px',
        boxHeight: '60px',
        bottom: '150px',
        left: '166px',
        bgSrc: 'https://rescdn.ssjj.cn/website/2025/03/18/61ddf3d6e7b8eb7cc0e3689302c85509.png'
      }
    ],

    part6Top: '5138px', // 任务赢货币活动位置
    part6Btns: [
      {
        itemWidth: '166px',
        itemHeight: '50px',
        DailyTaskWidth: '1200px',
        DailyTaskHeight: '50px',
        DailyTaskLeft: '487px',
        DailyTaskBottom: '620px',
        WeeklyTaskWidth: '950px',
        WeeklyTaskHeight: '50px',
        WeeklyTaskLeft: '732px',
        WeeklyTaskBottom: '350px',
        SpecialTaskWidth: '1195px',
        SpecialTaskHeight: '50px',
        SpecialTaskLeft: '500px',
        SpecialTaskBottom: '90px',
        bgWidth: '1920px',
        bgHeight: '1037px',
        bgSrc: 'https://rescdn.ssjj.cn/website/2025/03/21/ed25802902003134f29a51bb9136a560.jpg'
      }
    ],
    part6Text: [
      {
        DailyTaskWidth: '1060px',
        DailyTaskHeight: '40px',
        DailyTaskLeft: '630px',
        DailyTaskBottom: '690px',
        WeeklyTaskWidth: '840px',
        WeeklyTaskHeight: '40px',
        WeeklyTaskLeft: '850px',
        WeeklyTaskBottom: '421px',
        SpecialTaskWidth: '1110px',
        SpecialTaskHeight: '40px',
        SpecialTaskLeft: '588px',
        SpecialTaskBottom: '160px',
        color: '#FDD738',
        fontSize: '18px'
      }
    ],

    part7Top: '6177px', // 好友任务活动位置
    part7Obj: [
      {
        itemWidth: '166px',
        itemHeight: '50px',
        bgWidth: '1920px',
        bgHeight: '1119px',
        bgSrc: 'https://rescdn.ssjj.cn/website/2025/03/26/2a9ef2ee12be342ca5a3c3f7f42d3fb1.jpg',
        inviteSrc: 'https://rescdn.ssjj.cn/website/2025/03/18/82e256787f976f3fb7aa24638f295b1d.png',
        joinSrc: 'https://rescdn.ssjj.cn/website/2025/03/18/ff79c63404d8b39ad4ab56aaf190ccc6.png'
      }
    ],
    part7Btns: [
      {
        inviteWidth: '680px',
        inviteHeight: '50px',
        inviteLeft: '500px',
        inviteBottom: '670px',
        taskWidth: '166px',
        taskHeight: '530px',
        taskLeft: '1500px',
        taskBottom: '100px'
      }
    ],
    part7Text: [
      {
        fontSize: '26px',
        color: '#FDD738',
        inviteTextLeft: '1360px',
        inviteTextBottom: '680px'
      }
    ],
    part8Top: '7290px', // 新回活动位置
    part8Obj: [
      {
        itemWidth: '166px',
        itemHeight: '50px',
        bgWidth: '1920px',
        bgHeight: '835px',
        bgSrc: 'https://rescdn.ssjj.cn/website/2025/03/26/3841d9f8f4ea3961f5b18dd280a81b3e.jpg',
        left: '460px',
        bottom: '200px',
        boxWidth: '1000px',
        boxHeight: '60px'
      }
    ],
    // ===== 活动 ID 配置 =====
    // 抽奖：GBEQB47DMRGJAXFUDRXAJ64PS4
    // 点券购买：ZMERCTKBZETKUQYQDZ2OW3RNTI
    // 累计抽奖：5VHHMT4E7TRM4BAZCHGAVZ4KXI
    // 签到：LEONEAB6YTRLYP3FIPFI62RF64
    // 累登：5KI3D4D2UC4ZPBDE2A663YN6A4
    // 周末福利：5SWPSJE72SCN6KQHCELZJKAE3M
    // 周期任务：5PHDCQNKOPXPPZVG53BN2T3XZQ
    // 组队任务：4YKTZPG7SBGMRAQIWWY2VPYLWQ
    // 新回活动：D7F6AQREX2GQMYV4HZM26AZ7FY

    activityId1: 'GBEQB47DMRGJAXFUDRXAJ64PS4', // 抽奖
    activityId2: 'ZMERCTKBZETKUQYQDZ2OW3RNTI', // 点券购买
    activityId3: '5VHHMT4E7TRM4BAZCHGAVZ4KXI', // 累计抽奖
    activityId4: 'LEONEAB6YTRLYP3FIPFI62RF64', // 签到
    activityId5: '5KI3D4D2UC4ZPBDE2A663YN6A4', // 累登
    activityId6: '5SWPSJE72SCN6KQHCELZJKAE3M', // 周末福利
    activityId7: '5PHDCQNKOPXPPZVG53BN2T3XZQ', // 周期任务
    activityId8: '4YKTZPG7SBGMRAQIWWY2VPYLWQ', // 组队任务
    activityId9: 'D7F6AQREX2GQMYV4HZM26AZ7FY', // 新回活动
    activityId10: 'ZSONBQR6QORQ72BXPBPZ7TXYRE', // 武器购买活动
    // ===== text color =====
    textColorLevel1: '#333',
    textColorLevel2: '#666',
    textColorLevel3: '#999',
    textColorActive: '#C3636B',
    miniBtnColor: '#EA0037',

    // ===== 领取按钮 =====
    // 未开始按钮
    receiveBtn0: {
      src: 'https://rescdn.ssjj.cn/website/2025/03/17/ae8fddf53a9840a1eb1f539887dea63d.png'
    },
    // 未完成按钮
    receiveBtn1: {
      src: 'https://rescdn.ssjj.cn/website/2025/03/17/ae8fddf53a9840a1eb1f539887dea63d.png'
    },
    // 领取按钮
    receiveBtn2: {
      src: 'https://rescdn.ssjj.cn/website/2025/03/17/ae8fddf53a9840a1eb1f539887dea63d.png'
    },
    // 已领取按钮
    receiveBtn3: {
      src: 'https://rescdn.ssjj.cn/website/2025/03/17/2617a5f4d883e8a9b9d55db41a4dc37b.png'
    },
    // 已过期按钮
    receiveBtn4: {
      src: 'https://rescdn.ssjj.cn/website/2025/03/17/15827825c89f89eb2208c54ee4298ef5.png'
    },
    // ===== 抽奖按钮 =====
    // drawActiveItem: '1,2',
    drawBgColor: '#C4CCE6,#E8E9EC',
    drawBgColorActive: '#FFBE57,#FFE8BB',

    // ====== 侧边栏 ======
    textColor: '#000',
    textHoverColor: '#fff',
    sideBarNavShowDistance: '1000',
    sideBarNavText: [
      {
        id: 'version-data-1',
        bgSrc: 'https://rescdn.ssjj.cn/website/2025/03/20/6f81031f605f1d3820b5df766bd0ef2b.png'
      },
      {
        id: 'version-data-2',
        bgSrc: 'https://rescdn.ssjj.cn/website/2025/03/20/c40b3e6fb65233da18699c921005685a.png'
      },
      {
        id: 'version-data-3',
        bgSrc: 'https://rescdn.ssjj.cn/website/2025/03/20/1a683cd0a8b35c9927e2667bd5328632.png'
      },
      {
        id: 'version-data-4',
        bgSrc: 'https://rescdn.ssjj.cn/website/2025/03/20/18aec528ec4c786cb32ebdde8206dcad.png'
      },
      {
        id: 'version-data-5',
        bgSrc: 'https://rescdn.ssjj.cn/website/2025/03/20/1af599f34205efe5df8fd5d9e0d1a627.png'
      },
      {
        id: 'version-data-6',
        bgSrc: 'https://rescdn.ssjj.cn/website/2025/03/20/c1883c8036b6508f5e27bd825ea0f956.png'
      },
      {
        id: 'version-data-7',
        bgSrc: 'https://rescdn.ssjj.cn/website/2025/03/20/e3567e69471d60786a634f003be508cc.png'
      },
      {
        id: 'version-data-8',
        bgSrc: 'https://rescdn.ssjj.cn/website/2025/03/20/a13a9765fa8ef29ec98b60ef78abe7f1.png'
      }
    ],
    sliderBox: [
      {
        boxWidth: '1600px',
        itemHeight: '98px',
        itemWidth: '341px'
      }
    ],
    sliderTop: '15%',

    // 弹窗相关
    modalBg: {
      src: 'https://rescdn.ssjj.cn/website/2024/05/17/a6bba4d3e7bcc51f1ef47eeb6e40cf6d.png',
      style: {
        width: '750px',
        height: '650px'
      }
    },
    modalCloseIcon: {
      src: 'https://rescdn.ssjj.cn/website/2024/03/13/f76e2285005d4f4cdc20b79f15a87f5b.png',
      style: {
        width: '54px',
        height: '42px',
        right: '-60px',
        top: '0px'
      }
    },
    modalTitleStyle: '{"color": "#A81548", "opacity": "0.8", "font-weight": "700"}',
    modalTextStyle: '{"color": "#ffffff"}',
    modalConfirmBtnStyle: '{"background-image":"url(https://rescdn.ssjj.cn/website/2024/03/15/99b4684fb700b34aa5da97b1024be328.png)","color": "#FFF", "font-weight": "700"}',
    modalCancelBtnStyle: '{"background-image":"url(https://rescdn.ssjj.cn/website/2024/03/15/b4c489022fc32a83793352f2e4d29c78.png)","color": "#FFF", "font-weight": "700"}'
  },
  propsDesc: [
    // 公共 配置 start
    {
      target: '=== 公共 配置 start ===',
      formType: 'divider'
    },
    {
      target: 'part1Id',
      label: '转盘活动锚点'
    },
    {
      target: 'part2Id',
      label: '定制武器锚点'
    },
    {
      target: 'part3Id',
      label: '签到活动锚点'
    },
    {
      target: 'part4Id',
      label: '累登活动锚点'
    },
    {
      target: 'part5Id',
      label: '周末福利活动锚点'
    },
    {
      target: 'part6Id',
      label: '周期任务活动锚点'
    },
    {
      target: 'part7Id',
      label: '组队任务活动锚点'
    },
    {
      target: 'part8Id',
      label: '新回活动锚点'
    },
    {
      target: 'sliderTop',
      label: '导航容器距离顶部距离'
    },
    {
      target: 'sliderBox',
      label: '导航容器',
      formType: 'list',
      listConfig: [
        {
          title: '容器宽度',
          target: 'boxWidth'
        },
        {
          title: '图片宽度',
          target: 'itemWidth'
        },
        {
          title: '图片高度',
          target: 'itemHeight'
        }
      ]
    },
    {
      target: 'sideBarNavText',
      label: '导航文本',
      formType: 'list',
      listConfig: [
        {
          title: '图片src',
          src: 'https://rescdn.ssjj.cn/website/2025/03/20/6f81031f605f1d3820b5df766bd0ef2b.png',
          target: 'bgSrc'
        },
        {
          title: '锚点ID',
          target: 'id'
        }
      ]
    },
    {
      target: 'sideBarNavShowDistance',
      label: '侧边栏显示距离'
    },
    {
      target: 'ruleId',
      label: '规则ID'
    },
    // '=== 公共 配置 end ===
    {
      target: '=== 公共 配置 end ===',
      formType: 'divider'
    },
    // 抽奖 配置 start
    {
      target: '=== 抽奖 配置 start ===',
      formType: 'divider'
    },
    {
      target: 'part1Top',
      label: '转盘活动定位'
    },
    {
      target: 'lotteryCost',
      label: '抽奖消耗'
    },
    {
      target: 'part1Obj',
      label: '抽奖活动配置',
      formType: 'list',
      listConfig: [
        {
          title: '图片宽度',
          target: 'bgWidth'
        },
        {
          title: '图片高度',
          target: 'bgHeight'
        },
        {
          title: '图片背景链接',
          target: 'bgSrc'
        }
      ]
    },
    {
      target: 'part1Btn',
      label: '货币购买',
      formType: 'list',
      listConfig: [
        {
          title: '图片宽度',
          target: 'btnWidth'
        },
        {
          title: '图片高度',
          target: 'btnHeight'
        },
        {
          title: '图片背景链接',
          target: 'btnSrc'
        },
        {
          title: '按钮位置left',
          target: 'left'
        },
        {
          title: '按钮位置bottom',
          target: 'bottom'
        }
      ]
    },
    {
      target: 'part1Rule',
      label: '抽奖规则',
      formType: 'list',
      listConfig: [
        {
          title: '图片宽度',
          target: 'btnWidth'
        },
        {
          title: '图片高度',
          target: 'btnHeight'
        },
        {
          title: '图片背景链接',
          target: 'btnSrc'
        },
        {
          title: '按钮位置left',
          target: 'left'
        },
        {
          title: '按钮位置bottom',
          target: 'bottom'
        }
      ]
    },
    {
      target: 'part1TextStyle',
      label: '货币余额样式',
      formType: 'list',
      listConfig: [
        {
          title: '文字大小',
          target: 'fontSize'
        },
        {
          title: '文字颜色',
          target: 'color'
        },
        {
          title: '文字位置left',
          target: 'left'
        },
        {
          title: '文字位置top',
          target: 'top'
        }
      ]
    },
    {
      target: 'part1Record',
      label: '领取记录',
      formType: 'list',
      listConfig: [
        {
          title: '图片宽度',
          target: 'btnWidth'
        },
        {
          title: '图片高度',
          target: 'btnHeight'
        },
        {
          title: '图片背景链接',
          target: 'btnSrc'
        },
        {
          title: '按钮位置left',
          target: 'left'
        },
        {
          title: '按钮位置bottom',
          target: 'bottom'
        }
      ]
    },
    {
      target: 'prat1ReciveGiftBox',
      label: '领取累计容器',
      formType: 'list',
      listConfig: [
        {
          title: '容器宽度',
          target: 'width'
        },
        {
          title: '容器高度',
          target: 'height'
        },
        {
          title: '领取按钮高度',
          target: 'btnHeight'
        },
        {
          title: '领取按钮宽度',
          target: 'btnWidth'
        },
        {
          title: '容器位置left',
          target: 'left'
        },
        {
          title: '容器位置bottom',
          target: 'bottom'
        }
      ]
    },
    {
      target: 'prat1ReciveTextBox',
      label: '领取累计文本容器',
      formType: 'list',
      listConfig: [
        {
          title: '容器宽度',
          target: 'width'
        },
        {
          title: '容器高度',
          target: 'height'
        },
        {
          title: '容器位置left',
          target: 'left'
        },
        {
          title: '容器位置bottom',
          target: 'bottom'
        },
        {
          title: '文字大小',
          target: 'fontSize'
        },
        {
          title: '文字颜色',
          target: 'color'
        }
      ]
    },
    {
      target: 'lotteryBtn',
      label: '抽一次按钮配置',
      formType: 'list',
      listConfig: [
        {
          title: '图片宽度',
          target: 'btnWidth'
        },
        {
          title: '图片高度',
          target: 'btnHeight'
        },
        {
          title: '图片背景链接',
          target: 'btnSrc'
        },
        {
          title: '按钮位置left',
          target: 'left'
        },
        {
          title: '按钮位置bottom',
          target: 'bottom'
        }
      ]
    },
    {
      target: 'lotteryTenBtn',
      label: '抽10次按钮配置',
      formType: 'list',
      listConfig: [
        {
          title: '图片宽度',
          target: 'btnWidth'
        },
        {
          title: '图片高度',
          target: 'btnHeight'
        },
        {
          title: '图片背景链接',
          target: 'btnSrc'
        },
        {
          title: '按钮位置left',
          target: 'left'
        },
        {
          title: '按钮位置bottom',
          target: 'bottom'
        }
      ]
    },
    // === 抽奖 配置 end ===
    {
      target: '=== 抽奖 配置 end ===',
      formType: 'divider'
    },
    {
      target: '=== 武器直购 配置 start ===',
      formType: 'divider'
    },
    {
      target: 'part2Top',
      label: '武器直购活动定位'
    },
    {
      target: 'part2Obj',
      label: '武器直购活动配置',
      formType: 'list',
      listConfig: [
        {
          title: '图片宽度',
          target: 'bgWidth'
        },
        {
          title: '图片高度',
          target: 'bgHeight'
        },
        {
          title: '图片背景链接',
          target: 'bgSrc'
        },
        {
          title: '购买按钮宽度',
          target: 'itemWidth'
        },
        {
          title: '购买按钮高度',
          target: 'itemHeight'
        },
        {
          title: '购买按钮背景',
          target: 'btnSrc'
        },
        {
          title: '按钮位置left',
          target: 'left'
        },
        {
          title: '按钮位置bottom',
          target: 'bottom'
        }
      ]
    },
    {
      target: '=== 武器直购 配置 end ===',
      formType: 'divider'
    },
    {
      target: '=== 签到领取 配置 start ===',
      formType: 'divider'
    },
    {
      target: 'part3Top',
      label: '武器直购活动定位'
    },
    {
      target: 'part3Obj',
      label: '签到领取活动配置',
      formType: 'list',
      listConfig: [
        {
          title: '图片宽度',
          target: 'bgWidth'
        },
        {
          title: '图片高度',
          target: 'bgHeight'
        },
        {
          title: '图片背景链接',
          target: 'bgSrc'
        },
        {
          title: '签到按钮宽度',
          target: 'itemWidth'
        },
        {
          title: '签到按钮高度',
          target: 'itemHeight'
        }
      ]
    },
    {
      target: 'part3BtnsFirst',
      label: '签到领取活动配置-第一个',
      formType: 'list',
      listConfig: [
        {
          title: '按钮位置left',
          target: 'left'
        },
        {
          title: '按钮位置bottom',
          target: 'bottom'
        }
      ]
    },
    {
      target: 'part3BtnsOther',
      label: '签到领取活动容器配置-剩余部分',
      formType: 'list',
      listConfig: [
        {
          title: '容器宽度',
          target: 'boxWidth'
        },
        {
          title: '容器高度',
          target: 'boxHeight'
        },
        {
          title: '按钮位置left',
          target: 'left'
        },
        {
          title: '按钮位置bottom',
          target: 'bottom'
        }
      ]
    },
    {
      target: '=== 签到领取 配置 end ===',
      formType: 'divider'
    },
    {
      target: '=== 版本累登 配置 start ===',
      formType: 'divider'
    },
    {
      target: 'part4Top',
      label: '版本累登活动定位'
    },
    {
      target: 'part4Btns',
      label: '版本累登活动按钮',
      formType: 'list',
      listConfig: [
        {
          title: '按钮宽度',
          target: 'itemWidth'
        },
        {
          title: '按钮高度',
          target: 'itemHeight'
        },
        {
          title: '容器宽度',
          target: 'bgWidth'
        },
        {
          title: '容器高度',
          target: 'bgHeight'
        },
        {
          title: '按钮容器宽度',
          target: 'boxWidth'
        },
        {
          title: '按钮容器高度',
          target: 'boxHeight'
        },
        {
          title: '按钮容器位置left',
          target: 'left'
        },
        {
          title: '按钮容器位置bottom',
          target: 'bottom'
        },
        {
          title: '按钮容器背景',
          target: 'bgSrc'
        }
      ]
    },
    {
      target: 'part4LoginCount',
      label: '版本累登活动登录次数',
      formType: 'list',
      listConfig: [
        {
          title: '按钮容器位置left',
          target: 'left'
        },
        {
          title: '按钮容器位置bottom',
          target: 'bottom'
        },
        {
          title: '字体大小',
          target: 'fontSize'
        },
        {
          title: '字体颜色',
          target: 'color'
        }
      ]
    },
    {
      target: '=== 版本累登 配置 end ===',
      formType: 'divider'
    },
    {
      target: '=== 周末福利 配置 start ===',
      formType: 'divider'
    },
    {
      target: 'part5Top',
      label: '周末福利活动定位'
    },
    {
      target: 'part5Btns',
      label: '周末福利活动按钮',
      formType: 'list',
      listConfig: [
        {
          title: '按钮宽度',
          target: 'itemWidth'
        },
        {
          title: '按钮高度',
          target: 'itemHeight'
        },
        {
          title: '容器宽度',
          target: 'bgWidth'
        },
        {
          title: '容器高度',
          target: 'bgHeight'
        },
        {
          title: '按钮容器宽度',
          target: 'boxWidth'
        },
        {
          title: '按钮容器高度',
          target: 'boxHeight'
        },
        {
          title: '按钮容器位置left',
          target: 'left'
        },
        {
          title: '按钮容器位置bottom',
          target: 'bottom'
        },
        {
          title: '按钮容器背景',
          target: 'bgSrc'
        }
      ]
    },
    {
      target: '=== 周末福利 配置 end ===',
      formType: 'divider'
    },
    {
      target: '=== 任务赢货币 配置 start ===',
      formType: 'divider'
    },
    {
      target: 'part6Top',
      label: '任务赢货币活动定位'
    },
    {
      target: 'part6Btns',
      label: '任务赢货币活动按钮',
      formType: 'list',
      listConfig: [
        {
          title: '按钮宽度',
          target: 'itemWidth'
        },
        {
          title: '按钮高度',
          target: 'itemHeight'
        },
        {
          title: '每日任务容器宽度',
          target: 'DailyTaskWidth'
        },
        {
          title: '每日任务容器高度',
          target: 'DailyTaskHeight'
        },
        {
          title: '每日任务容器位置left',
          target: 'DailyTaskLeft'
        },
        {
          title: '每日任务容器位置bottom',
          target: 'DailyTaskBottom'
        },
        {
          title: '每周任务容器宽度',
          target: 'WeeklyTaskWidth'
        },
        {
          title: '每周任务高度',
          target: 'WeeklyTaskHeight'
        },
        {
          title: '每周任务容器位置left',
          target: 'WeeklyTaskLeft'
        },
        {
          title: '每周任务容器位置bottom',
          target: 'WeeklyTaskBottom'
        },
        {
          title: '特殊任务容器宽度',
          target: 'SpecialTaskWidth'
        },
        {
          title: '特殊任务高度',
          target: 'SpecialTaskHeight'
        },
        {
          title: '特殊任务容器位置left',
          target: 'SpecialTaskLeft'
        },
        {
          title: '特殊任务容器位置bottom',
          target: 'SpecialTaskBottom'
        },
        {
          title: '容器宽度',
          target: 'bgWidth'
        },
        {
          title: '容器高度',
          target: 'bgHeight'
        },
        {
          title: '按钮容器背景',
          target: 'bgSrc'
        }
      ]
    },
    {
      target: 'part6Text',
      label: '任务赢货币活动文本',
      formType: 'list',
      listConfig: [
        {
          title: '每日任务容器宽度',
          target: 'DailyTaskWidth'
        },
        {
          title: '每日任务容器高度',
          target: 'DailyTaskHeight'
        },
        {
          title: '每日任务容器位置left',
          target: 'DailyTaskLeft'
        },
        {
          title: '每日任务容器位置bottom',
          target: 'DailyTaskBottom'
        },
        {
          title: '每周任务容器宽度',
          target: 'WeeklyTaskWidth'
        },
        {
          title: '每周任务高度',
          target: 'WeeklyTaskHeight'
        },
        {
          title: '每周任务容器位置left',
          target: 'WeeklyTaskLeft'
        },
        {
          title: '每周任务容器位置bottom',
          target: 'WeeklyTaskBottom'
        },
        {
          title: '特殊任务容器宽度',
          target: 'SpecialTaskWidth'
        },
        {
          title: '特殊任务高度',
          target: 'SpecialTaskHeight'
        },
        {
          title: '特殊任务容器位置left',
          target: 'SpecialTaskLeft'
        },
        {
          title: '特殊任务容器位置bottom',
          target: 'SpecialTaskBottom'
        },
        {
          title: '文本颜色',
          target: 'color'
        },
        {
          title: '文本大小',
          target: 'fontSize'
        }
      ]
    },
    {
      target: '=== 任务赢货币 配置 end ===',
      formType: 'divider'
    },
    {
      target: '=== 好友任务 配置 start ===',
      formType: 'divider'
    },
    {
      target: 'part7Top',
      label: '好友任务活动定位'
    },
    {
      target: 'part7Obj',
      label: '好友任务活动对象',
      formType: 'list',
      listConfig: [
        {
          title: '按钮宽度',
          target: 'itemWidth'
        },
        {
          title: '按钮高度',
          target: 'itemHeight'
        },
        {
          title: '容器宽度',
          target: 'bgWidth'
        },
        {
          title: '容器高度',
          target: 'bgHeight'
        },
        {
          title: '邀请按钮',
          target: 'inviteSrc'
        },
        {
          title: '加入按钮',
          target: 'joinSrc'
        },
        {
          title: '按钮容器背景',
          target: 'bgSrc'
        }
      ]
    },
    {
      target: 'part7Btns',
      label: '好友任务活动按钮',
      formType: 'list',
      listConfig: [
        {
          title: '邀请容器宽度',
          target: 'inviteWidth'
        },
        {
          title: '邀请容器高度',
          target: 'inviteHeight'
        },
        {
          title: '邀请容器位置left',
          target: 'inviteLeft'
        },
        {
          title: '邀请容器位置bottom',
          target: 'inviteBottom'
        },
        {
          title: '任务容器宽度',
          target: 'taskWidth'
        },
        {
          title: '任务容器高度',
          target: 'taskHeight'
        },
        {
          title: '任务容器位置left',
          target: 'taskLeft'
        },
        {
          title: '任务容器位置bottom',
          target: 'taskBottom'
        }
      ]
    },
    {
      target: 'part7Text',
      label: '好友任务活动文本',
      formType: 'list',
      listConfig: [
        {
          title: '字体大小',
          target: 'fontSize'
        },
        {
          title: '文本颜色',
          target: 'color'
        },
        {
          title: '文字位置left',
          target: 'inviteTextLeft'
        },
        {
          title: '文字位置bottom',
          target: 'inviteTextBottom'
        }
      ]
    },
    {
      target: '=== 好友任务 配置 end ===',
      formType: 'divider'
    },
    {
      target: '=== 新回活动 配置 start ===',
      formType: 'divider'
    },
    {
      target: 'part8Top',
      label: '新回活动定位'
    },
    {
      target: 'part8Obj',
      label: '新回活动对象',
      formType: 'list',
      listConfig: [
        {
          title: '按钮宽度',
          target: 'itemWidth'
        },
        {
          title: '按钮高度',
          target: 'itemHeight'
        },
        {
          title: '背景宽度',
          target: 'bgWidth'
        },
        {
          title: '背景高度',
          target: 'bgHeight'
        },
        {
          title: '容器宽度',
          target: 'boxWidth'
        },
        {
          title: '容器高度',
          target: 'boxHeight'
        },
        {
          title: '按钮容器背景',
          target: 'bgSrc'
        },
        {
          title: '按钮容器位置left',
          target: 'left'
        },
        {
          title: '按钮容器位置bottom',
          target: 'bottom'
        }
      ]
    },
    {
      target: '=== 新回活动 配置 end ===',
      formType: 'divider'
    },
    {
      target: '=== 活动 ID 配置 ===',
      formType: 'divider'
    },
    {
      target: 'activityId1',
      label: '抽奖活动ID'
    },
    {
      target: 'activityId2',
      label: '探险币购买活动ID'
    },
    {
      target: 'activityId3',
      label: '累计抽奖活动ID'
    },
    {
      target: 'activityId4',
      label: '签到活动ID'
    },
    {
      target: 'activityId5',
      label: '累登活动ID'
    },
    {
      target: 'activityId6',
      label: '周末福利活动ID'
    },
    {
      target: 'activityId7',
      label: '周期任务活动ID'
    },
    {
      target: 'activityId8',
      label: '组队任务活动ID'
    },
    {
      target: 'activityId9',
      label: '新回活动ID'
    },
    {
      target: 'activityId10',
      label: '武器购买活动ID'
    },
    {
      target: '公共文本颜色',
      formType: 'divider'
    },
    {
      target: 'textColorLevel1',
      label: '一级文本颜色',
      formType: 'color'
    },
    {
      target: 'textColorLevel2',
      label: '二级文本颜色',
      formType: 'color'
    },
    {
      target: 'textColorLevel3',
      label: '三级文本颜色',
      formType: 'color'
    },
    {
      target: 'textColorActive',
      label: '活跃文本颜色',
      formType: 'color'
    },
    {
      target: 'miniBtnColor',
      label: '小按钮颜色',
      formType: 'color'
    },

    {
      target: '---补给商店列表---',
      formType: 'divider'
    },
    {
      target: 'shopList',
      label: '购买物品列表',
      formType: 'list',
      listConfig: [
        {
          title: '物品图',
          target: 'awardImg'
        },
        {
          title: '按钮图',
          target: 'btnImg'
        }
      ]
    },
    {
      target: '--抽奖相关--',
      formType: 'divider'
    },
    // {
    //   target: 'drawActiveItem',
    //   label: '高亮显示项'
    // },
    {
      target: 'drawBgColor',
      label: '默认背景过渡色'
    },
    {
      target: 'drawBgColorActive',
      label: '高亮背景过渡色'
    },
    {
      target: '-----领取按钮-----',
      formType: 'divider'
    },
    {
      target: 'receiveBtn0',
      label: '未开始按钮',
      formType: 'image'
    },
    {
      target: 'receiveBtn1',
      label: '未完成按钮',
      formType: 'image'
    },
    {
      target: 'receiveBtn2',
      label: '领取按钮',
      formType: 'image'
    },
    {
      target: 'receiveBtn3',
      label: '已领取按钮',
      formType: 'image'
    },
    {
      target: 'receiveBtn4',
      label: '已过期按钮',
      formType: 'image'
    },
    {
      target: 'textColor',
      label: '侧边栏默认色值',
      formType: 'color'
    },
    {
      target: 'textHoverColor',
      label: '侧边栏选中色值',
      formType: 'color'
    },
    {
      target: '===== 公共弹窗 ======',
      formType: 'divider'
    },
    {
      target: 'modalBg',
      label: '弹窗背景图',
      formType: 'image'
    },
    {
      target: 'modalCloseIcon',
      label: '关闭按钮',
      formType: 'image'
    },
    {
      target: 'modalTitleStyle',
      label: '标题样式',
      formType: 'textarea'
    },
    {
      target: 'modalTextStyle',
      label: '文本样式',
      formType: 'textarea'
    },
    {
      target: 'modalConfirmBtnStyle',
      label: '确认按钮样式',
      formType: 'textarea'
    },
    {
      target: 'modalCancelBtnStyle',
      label: '取消按钮样式',
      formType: 'textarea'
    },
    {
      target: 'mainHeight',
      label: '主体高度'
    }
  ],

  // 样式相关
  styles: {
    ..._mixin.styles
  },
  stylesDesc: [
    ..._mixin.stylesDesc
  ],

  // 事件相关
  events: {
    // click: () => {} 无需配置
  },
  eventsList: [
    // eventTpl 无需配置
  ],
  eventsDesc: [
    ..._mixin.eventsDesc
  ],

  methods: [
    ..._mixin.methods
  ],
  children: [
    // {
    //   id: genId() + '_BaseGroup_0',
    //   ...BaseGroup
    // },
    // {
    //   id: genId() + '_BaseGroup_1',
    //   ...BaseGroup
    // }
  ]
}
